/* ========================================================================== 
   Shopp Games - pagina de produto / camada visual segura para Merchant

   Regra central:
   - O preco oficial SEMPRE vem do Liquid/Shopify, em centavos, pelo atributo
     data-sg-price-cents do snippet price.liquid.
   - Pix e parcelas sao apenas apresentacao derivada desse preco.
   - Nunca lemos/preenchemos o preco oficial a partir de texto formatado.
   - Nunca desmarcamos a variante que a Shopify selecionou.
   - URL com ?variant= permanece naquela variante desde o primeiro render.

   O visual permanece igual ao layout Shopp Games existente.
   ========================================================================== */
(function () {
  'use strict';

  var LABEL_BUY = 'COMPRAR AGORA';
  var LABEL_CHOOSE = 'ESCOLHA UMA OPÇÃO';
  var MIN_INSTALLMENT = 6.5;
  var INTEREST = [
    0,
    0,
    0,
    7.593796898449225,
    9.154577288644322,
    10.72536268134067,
    12.30115057528764,
    13.93696848424212,
    15.52776388194097,
    17.15857928964482,
    18.80440220110055,
    20.48024012006003
  ];

  var ICON_PIX =
    '<svg class="sg-pix__icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">' +
    '<path d="M5.283 18.36c.951 0 1.844-.371 2.517-1.043l3.643-3.643a.494.494 0 0 1 .674-.001l3.658 3.658a3.532 ' +
    '3.532 0 0 0 2.516 1.041h.718l-4.62 4.617a3.687 3.687 0 0 1-5.21 0L4.55 18.36ZM18.29 5.638c-.95 0-1.843.372' +
    '-2.516 1.043l-3.658 3.658a.477.477 0 0 1-.674 0L7.8 6.686A3.532 3.532 0 0 0 5.282 5.64h-.732l4.63-4.626a3.' +
    '686 3.686 0 0 1 5.21 0l4.616 4.624ZM3.807 6.375h1.476c.656 0 1.3.266 1.763.73l3.643 3.643a1.222 1.222 0 0 ' +
    '0 1.727 0l3.658-3.658a2.5 2.5 0 0 1 1.762-.73h1.906l2.788 2.79a3.686 3.686 0 0 1 0 5.21l-2.788 2.79h-1.906' +
    'a2.5 2.5 0 0 1-1.762-.73l-3.657-3.658a1.257 1.257 0 0 0-1.728 0l-3.643 3.644a2.5 2.5 0 0 1-1.763.73H3.807l' +
    '-2.79-2.79a3.686 3.686 0 0 1 0-5.21Z"/></svg>';

  var ICON_CARD =
    '<svg class="sg-payments__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<rect x="2" y="5" width="20" height="14" rx="2.5"/><path d="M2 10h20"/><path d="M6 15h4"/></svg>';

  var ICON_CART =
    '<span class="sg-cart-icon" aria-hidden="true">' +
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" ' +
    'stroke-linejoin="round" focusable="false"><circle cx="9.5" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/>' +
    '<path d="M2.5 3.5h2.3l2.5 11.2a1.6 1.6 0 0 0 1.6 1.3h8.7a1.6 1.6 0 0 0 1.6-1.3L21 7.5H6.2"/></svg></span>';

  var CHEVRON =
    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16" aria-hidden="true">' +
    '<path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>' +
    '</svg>';

  var productDataCache;

  function getProductData() {
    if (productDataCache !== undefined) return productDataCache;
    var el = document.getElementById('sg-product-data');
    if (!el) return (productDataCache = null);
    try {
      productDataCache = JSON.parse(el.textContent);
    } catch (error) {
      productDataCache = null;
    }
    return productDataCache;
  }

  function formatBRL(value) {
    var numeric = Number(value);
    if (!Number.isFinite(numeric)) return '';
    var parts = numeric.toFixed(2).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$ ' + whole + ',' + parts[1];
  }

  function formatCents(cents) {
    return formatBRL(Number(cents) / 100);
  }

  function priceCard(container) {
    return container.querySelector('[id^="price-template"]');
  }

  function nativePriceNode(container) {
    var card = priceCard(container);
    return card ? card.querySelector('.price[data-sg-price-cents]') : null;
  }

  function nativePriceCents(container) {
    var node = nativePriceNode(container);
    if (!node) return null;
    var cents = Number(node.getAttribute('data-sg-price-cents'));
    return Number.isFinite(cents) && cents >= 0 ? Math.round(cents) : null;
  }

  function variantInputs(container) {
    return container.querySelectorAll('.product-form__input--pill input[type="radio"]');
  }

  function hasVariantInUrl() {
    try {
      return new URLSearchParams(window.location.search).has('variant');
    } catch (error) {
      return false;
    }
  }

  function initChoiceState(container) {
    if (container.dataset.sgChoiceInit === '1') return;
    var data = getProductData();
    var hasMultipleChoices = variantInputs(container).length > 1 || (data && Number(data.variantCount) > 1);

    /* Mantem a mesma UX anterior: em produto com mais de uma escolha, o cliente
       ainda precisa clicar antes de comprar. A diferenca e que a variante que a
       Shopify selecionou continua tecnicamente marcada no HTML. */
    container.dataset.sgVariantChosen = hasMultipleChoices ? '0' : '1';
    container.dataset.sgChoiceInit = '1';
  }

  function isAwaitingChoice(container) {
    return container.dataset.sgVariantChosen !== '1' && variantInputs(container).length > 1;
  }

  function provisionalPriceCents(container) {
    /* Em URL de variante, o valor provisório precisa continuar sendo o da
       variante recebida pela Shopify. Sem ?variant= mantemos o "a partir de"
       usando o menor preco, exatamente como no visual atual. */
    if (hasVariantInUrl()) {
      var selectedCents = nativePriceCents(container);
      if (Number.isFinite(selectedCents)) return selectedCents;
    }

    var data = getProductData();
    if (data && Number.isFinite(Number(data.priceMin))) return Math.round(Number(data.priceMin));
    return nativePriceCents(container);
  }

  function ensureFromPrice(container) {
    var card = priceCard(container);
    if (!card) return;

    var cents = provisionalPriceCents(container);
    if (!Number.isFinite(cents)) return;

    var el = card.querySelector('.sg-from');
    if (!el) {
      el = document.createElement('div');
      el.className = 'sg-from';
      el.innerHTML = '<span class="sg-from__label">A partir de</span><span class="sg-from__value"></span>';
      card.insertBefore(el, card.firstChild);
    }
    el.querySelector('.sg-from__value').textContent = formatCents(cents);
  }

  function currentDisplayPriceCents(container) {
    if (isAwaitingChoice(container)) return provisionalPriceCents(container);
    return nativePriceCents(container);
  }

  function paymentData(priceCents) {
    var price = priceCents / 100;
    var data = getProductData();
    var pixPercent = data && Number.isFinite(Number(data.pixDiscountPercent)) ? Number(data.pixDiscountPercent) : 5;
    var pixCents = Math.round((priceCents * (100 - pixPercent)) / 100);
    var saveCents = priceCents - pixCents;
    var list = [];
    var mainInstallments = '';
    var mainInstallmentValue = '';

    for (var i = 0; i < INTEREST.length; i++) {
      var installments = i + 1;
      var total = price + (INTEREST[i] / 100) * price;
      var installmentValue = total / installments;

      if (installmentValue <= MIN_INSTALLMENT) break;

      if (i < 3) {
        mainInstallments = installments + 'x';
        mainInstallmentValue = formatBRL(installmentValue);
      }

      list.push(
        '<li>' +
          installments +
          '<b>x</b> de ' +
          formatBRL(installmentValue) +
          (i < 3 ? ' sem juros' : '') +
          '</li>'
      );
    }

    return {
      pixPercent: pixPercent,
      pixCents: pixCents,
      saveCents: saveCents,
      mainInstallments: mainInstallments,
      mainInstallmentValue: mainInstallmentValue,
      installmentListHtml: list.join('')
    };
  }

  function findButtonsWrap(container) {
    var children = container.children;
    for (var i = 0; i < children.length; i++) {
      if (children[i].querySelector('product-form, .product-form__buttons')) return children[i];
    }
    return null;
  }

  function bindPaymentToggles(payments) {
    var more = payments.querySelector('#mais-formas-pagamento');
    var list = payments.querySelector('.formas-pagamento');
    var installmentToggle = payments.querySelector('.forma[data-sg-toggle="parcelas"]');
    var parcelas = payments.querySelector('.parcelas');

    if (more && list) {
      more.addEventListener('click', function () {
        list.style.display = list.style.display === 'none' ? 'block' : 'none';
      });
    }

    if (installmentToggle && parcelas) {
      installmentToggle.addEventListener('click', function () {
        parcelas.style.display = parcelas.style.display === 'none' ? 'block' : 'none';
      });
    }
  }

  function renderPayments(container, forcedCents) {
    var hasForcedPrice =
      forcedCents !== null && forcedCents !== undefined && Number.isFinite(Number(forcedCents));
    var priceCents = hasForcedPrice ? Math.round(Number(forcedCents)) : currentDisplayPriceCents(container);
    if (!Number.isFinite(priceCents)) return;

    var card = priceCard(container);
    var buttonsWrap = findButtonsWrap(container);
    if (!card || !buttonsWrap) return;

    var currentBlock = container.querySelector('#formas-pagamento[data-sg-done="1"]');
    var currentPayments = container.querySelector('.sg-payments');
    if (
      currentBlock &&
      currentPayments &&
      currentBlock.dataset.sgPriceCents === String(priceCents) &&
      currentPayments.dataset.sgPriceCents === String(priceCents)
    ) {
      return;
    }

    var listWasOpen =
      currentPayments && currentPayments.querySelector('.formas-pagamento')
        ? currentPayments.querySelector('.formas-pagamento').style.display !== 'none'
        : false;
    var parcelasWasOpen =
      currentPayments && currentPayments.querySelector('.parcelas')
        ? currentPayments.querySelector('.parcelas').style.display !== 'none'
        : false;

    if (currentBlock) currentBlock.remove();
    if (currentPayments) currentPayments.remove();

    var values = paymentData(priceCents);

    var block = document.createElement('div');
    block.id = 'formas-pagamento';
    block.dataset.sgDone = '1';
    block.dataset.sgPriceCents = String(priceCents);
    block.innerHTML =
      '<div class="em-ate">' +
      '<div class="sg-pix">' +
      ICON_PIX +
      '<span class="sg-pix__label">PIX</span>' +
      '<span class="sg-pix__value">' +
      formatCents(values.pixCents) +
      '</span>' +
      '<span class="sg-pix__badge">' +
      String(values.pixPercent).replace('.', ',') +
      '% OFF</span>' +
      '</div>' +
      '<p class="sg-pix__save">Economize ' +
      formatCents(values.saveCents) +
      ' pagando no Pix</p>' +
      '</div>';

    var priceNode = card.querySelector('.price');
    if (priceNode) priceNode.insertAdjacentElement('afterend', block);
    else card.appendChild(block);

    var payments = document.createElement('div');
    payments.className = 'sg-payments';
    payments.dataset.sgPriceCents = String(priceCents);
    payments.innerHTML =
      '<div class="sg-payments__row">' +
      ICON_CARD +
      '<span>' +
      values.mainInstallments +
      ' de ' +
      values.mainInstallmentValue +
      ' sem juros</span>' +
      '</div>' +
      '<div id="mais-formas-pagamento">Mais formas de pagamento' +
      CHEVRON +
      '</div>' +
      '<div class="formas-pagamento" style="display: ' +
      (listWasOpen ? 'block' : 'none') +
      '">' +
      '<div>' +
      '<div class="forma" data-sg-toggle="parcelas">' +
      '<img loading="lazy" src="https://cdn.awsli.com.br/production/static/img/formas-de-pagamento/payu-cards.png?v=b0fcce2" alt="American Express, Visa, Diners, Mastercard, Aura, Hipercard, Elo">' +
      '<span>Parcelas</span>' +
      '</div>' +
      '<div class="parcelas" style="display: ' +
      (parcelasWasOpen ? 'block' : 'none') +
      '"><ul>' +
      values.installmentListHtml +
      '</ul></div>' +
      '<div class="forma">' +
      '<img loading="lazy" src="https://cdn.awsli.com.br/production/static/img/formas-de-pagamento/pagali-pix-logo.png?v=b0fcce2" alt="Pix">' +
      '<span>' +
      formatCents(values.pixCents) +
      '</span>' +
      '</div>' +
      '</div>' +
      '</div>';

    buttonsWrap.insertAdjacentElement('afterend', payments);
    bindPaymentToggles(payments);
  }

  function isVisible(el) {
    return !!el && el.offsetParent !== null;
  }

  function findBuyButton(container) {
    var candidates = container.querySelectorAll('.shopify-payment-button__button--unbranded');
    for (var i = 0; i < candidates.length; i++) {
      if (isVisible(candidates[i])) return candidates[i];
    }
    return null;
  }

  function setBuyLabel(button, label) {
    if (!button || button.dataset.sgLabel === label) return;
    button.textContent = label;
    button.dataset.sgLabel = label;
  }

  function applyChoiceGate(container) {
    var locked = isAwaitingChoice(container);
    var nativeUnavailable = container.dataset.sgNativeUnavailable === '1';
    var disabled = locked || nativeUnavailable;
    container.classList.toggle('sg-awaiting-choice', locked);

    if (locked) ensureFromPrice(container);

    var submit = container.querySelector('.product-form__submit');
    if (submit) {
      submit.disabled = disabled;
      submit.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    }

    var buy = findBuyButton(container);
    if (buy) {
      buy.disabled = disabled;
      buy.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      setBuyLabel(buy, locked ? LABEL_CHOOSE : LABEL_BUY);
    }
  }

  function applyCartIcon(container) {
    var submit = container.querySelector('.product-form__submit');
    if (!submit || submit.dataset.sgDone === '1') return;
    submit.insertAdjacentHTML('afterbegin', ICON_CART);
    submit.dataset.sgDone = '1';
  }

  function markComparePrice(container) {
    var strikes = container.querySelectorAll('.price__sale > span > s.price-item--regular');
    for (var i = 0; i < strikes.length; i++) {
      if (strikes[i].parentElement) strikes[i].parentElement.classList.add('sg-compare');
    }
  }

  function markBuyMode(container) {
    var buttons = container.querySelector('.product-form__buttons');
    if (!buttons) return;
    buttons.classList.toggle('sg-no-buy', !findBuyButton(container));
  }

  function freezeCardHeight(container) {
    var card = priceCard(container);
    if (!card) return;
    var height = Math.round(card.getBoundingClientRect().height);
    if (height > 0) card.style.minHeight = height + 'px';
  }

  function releaseCardHeight(container) {
    var card = priceCard(container);
    if (!card) return;
    window.setTimeout(function () {
      card.style.minHeight = '';
    }, 120);
  }

  function enhanceContainer(container, forcedCents) {
    if (!container) return;
    initChoiceState(container);
    if (container.dataset.sgNativeUnavailable === undefined) {
      var nativeSubmit = container.querySelector('.product-form__submit');
      container.dataset.sgNativeUnavailable = nativeSubmit && nativeSubmit.hasAttribute('disabled') ? '1' : '0';
    }
    markComparePrice(container);
    applyCartIcon(container);
    markBuyMode(container);
    applyChoiceGate(container);
    renderPayments(container, isAwaitingChoice(container) ? null : forcedCents);
  }

  function enhanceAll() {
    var containers = document.querySelectorAll('.product__info-container');
    for (var i = 0; i < containers.length; i++) enhanceContainer(containers[i]);
  }

  function watchChoice() {
    document.addEventListener(
      'change',
      function (event) {
        var target = event.target;
        if (!target || target.type !== 'radio' || !target.closest('.product-form__input--pill')) return;

        var container = target.closest('.product__info-container');
        if (!container) return;

        freezeCardHeight(container);
        container.dataset.sgVariantChosen = '1';
        applyChoiceGate(container);
      },
      true
    );
  }

  function containerForSection(sectionId) {
    var infos = document.querySelectorAll('product-info[data-section]');
    for (var i = 0; i < infos.length; i++) {
      if (infos[i].dataset.section === String(sectionId)) {
        return infos[i].querySelector('.product__info-container');
      }
    }
    return null;
  }

  function subscribeVariantChanges() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.variantChange) return;

    subscribe(PUB_SUB_EVENTS.variantChange, function (message) {
      var data = message && message.data ? message.data : null;
      if (!data || !data.variant) return;

      var container = containerForSection(data.sectionId);
      if (!container) {
        var containers = document.querySelectorAll('.product__info-container');
        container = containers.length ? containers[0] : null;
      }
      if (!container) return;

      container.dataset.sgVariantChosen = '1';
      container.dataset.sgNativeUnavailable = data.variant.available ? '0' : '1';
      enhanceContainer(container, Number(data.variant.price));
      releaseCardHeight(container);
    });
  }

  function start() {
    if (!document.querySelector('.product__info-container')) return;
    watchChoice();
    subscribeVariantChanges();
    enhanceAll();

    /* O botao "Compre ja" e injetado pelo script legado no fim do body.
       Esta segunda passada cobre carregamentos lentos sem polling continuo. */
    window.setTimeout(enhanceAll, 600);
    window.addEventListener('load', enhanceAll, { once: true });
    document.addEventListener('shopify:section:load', enhanceAll);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
